
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core";

import socket from "./component/socket/socket";
import { decryptData } from "./crypto";

const SessionExpiredPopup = () => {
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    let popupTimer;
    const handleSessionExpired = () => {
      // 600ms delay so manual logout redirection cancels popup display
      if (popupTimer) clearTimeout(popupTimer);
      popupTimer = setTimeout(() => {
        setOpen(true);
        setCountdown(5);
      }, 600);
    };

    window.addEventListener("session-expired", handleSessionExpired);

    // Socket listener for remote logout / password changed event
    if (socket && !socket.connected) {
      socket.connect();
    }

    const handleSocketLogout = (data) => {
      const encryptedUserId = sessionStorage.getItem("userId");
      const currentUserId = encryptedUserId ? decryptData(encryptedUserId) : null;

      // 1. Agar user logged in hi nahi h (e.g. Login Page par h), toh kuch mat karo
      if (!currentUserId) {
        return;
      }

      // 2. Agar ISI TAB ne password change kiya h, toh is tab ko logout mat karo
      const isThisTab = sessionStorage.getItem("is_password_changed_by_this_tab");
      if (isThisTab === "true") {
        sessionStorage.removeItem("is_password_changed_by_this_tab");
        return;
      }

      // 3. Sirf tab popup dikhao jab socket event ki userId current logged-in user se match kare
      if (data && data.userId && String(data.userId) === String(currentUserId)) {
        handleSessionExpired();
      }
    };

    socket.on("logoutAdmin", handleSocketLogout);
    // socket.on("password_changed_logout", handleSocketLogout);
    // socket.on("logout", handleSocketLogout);

    return () => {
      if (popupTimer) clearTimeout(popupTimer);
      window.removeEventListener("session-expired", handleSessionExpired);
      if (socket) {
        socket.off("logoutAdmin", handleSocketLogout);
        socket.off("password_changed_logout", handleSocketLogout);
        socket.off("logout", handleSocketLogout);
      }
    };
  }, []);

  useEffect(() => {
    let timer;

    if (open && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }

    if (open && countdown === 0) {
      handleLogout();
    }

    return () => clearInterval(timer);
  }, [open, countdown]);

  const handleLogout = () => {
    setOpen(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      PaperProps={{
        style: {
          borderRadius: 12,
          padding: "10px",
          maxWidth: 420,
          width: "100%"
        }
      }}
    >
      <DialogTitle style={{ textAlign: "center", fontWeight: 600 }}>
        Session Expired
      </DialogTitle>

      <DialogContent>
        <DialogContentText style={{ textAlign: "center", marginBottom: 10 }}>
          Your session has expired for security reasons.
        </DialogContentText>

        <Typography
          align="center"
          style={{
            fontSize: 16,
            fontWeight: 500
          }}
        >
          Logging out in{" "}
          <span style={{ color: "#d32f2f", fontWeight: 700 }}>
            {countdown}s
          </span>
        </Typography>
      </DialogContent>

      <DialogActions style={{ justifyContent: "center", paddingBottom: 20 }}>
        <Button
          onClick={handleLogout}
          variant="contained"
          color="secondary"
          style={{
            borderRadius: 8,
            padding: "8px 20px",
            fontWeight: 600
          }}
        >
          Log Out Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredPopup;

